import { API } from "@/lib/api";

/**
 * POST a JSON body to an SSE endpoint and invoke `onDelta` for every token.
 * Uses fetch (not EventSource) so we can POST and forward the auth cookie.
 * Returns the full accumulated text.
 */
export async function streamAI(path, body, onDelta, signal) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    signal,
  });

  if (!res.ok) {
    let detail = "AI request failed";
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch (e) {
      /* non-JSON error body */
    }
    throw new Error(detail);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";
    for (const line of lines) {
      if (!line.startsWith("data: ")) continue;
      const payload = line.slice(6);
      if (payload === "[DONE]") return full;
      const evt = JSON.parse(payload);
      if (evt.error) throw new Error(evt.error);
      if (evt.delta) {
        full += evt.delta;
        onDelta(full, evt.delta);
      }
    }
  }
  return full;
}
